export const markerLineWidth = 1;

export const markerRadius = 8;

export const markerBboxPadding = 10 + (markerRadius + markerLineWidth);
